import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetRoster = (periodId) => {
  const query = useApiQuery(
    ['courseAssignmentRoster', periodId],
    'schools',
    client => client.get(`/current-organization/course-assignment/periods/${periodId}/roster`),
    { enabled: !!periodId },
    { authenticated: true, version: 5 }
  )

  return {
    isLoading: query.isLoading,
    roster: query.data?.roster ?? [],
    error: query.error
  }
}
